// components/Header.js
import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

import imgcal from '../assetts/images/logo-bg.png';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Цвет меняется после 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AppBar
      position="sticky"
      sx={{
        background: isScrolled ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.6)',
        boxShadow: isScrolled
          ? '0px 4px 20px rgba(0, 0, 0, 0.4)'
          : '0px 4px 20px rgba(0, 0, 0, 0.2)',
        transition: 'background 0.3s, box-shadow 0.3s',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '50px',
        }}
      >
        {/* Новогодний логотип */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            letterSpacing: '1px',
            color: '#fff',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            animation: isScrolled ? 'sparkle 2s infinite' : 'none', // Блеск при скролле
            '@keyframes sparkle': {
              '0%, 100%': { color: '#fff' },
              '50%': { color: '#7514b6' }, // Золотистый цвет в середине анимации
            },
          }}
        >
          GameZone
        </Typography>

        {/* Кнопка для вызова */}
        <a
          href="tel:+996705130070"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fafafa',
            fontWeight: '500',
            textShadow: '1px 1px 8px rgba(255, 235, 59, 0.6)',
            textDecoration: 'none',
            borderRadius: '50%',
            transition: 'transform 0.3s, background 0.3s',
          }}
        >
          <img
            src={imgcal}
            alt="icon-call"
            style={{ width: '70px', height: '60px' }}
          />
        </a>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
